export class RunningAverage {
  private _totalSum: number;
  private _count: number;

  constructor() {
    this._totalSum = 0;
    this._count = 0;
  }

  getAverage(): number {
    // protect against division by zero
    return this._count === 0 ? 0 : this._totalSum / this._count;
  }

  getCount(): number {
    return this._count;
  }

  getTotalSum(): number {
    return this._totalSum;
  }

  /**
   * Adds values to the RunningAverage. Returns the RunningAverage instance for chaining purposes.
   */
  add(...values: number[]) {
    for (const value of values) {
      this._totalSum += value;
    }
    this._count += values.length;

    return this;
  }

  /**
   * If the RunningAverage is cast to a primitive (string or number), return the average number.
   * This technically means you could use a RunningAverage instance as a number,
   * but TypeScript will unfortunately most likely yell at you.
   * @example
   * const average = new RunningAverage();
   * average.add(10, 20, 30);
   * console.log(average); // 20
   * Number(average); // 20
   * average + 10; // 30
   */
  [Symbol.toPrimitive](): number {
    return this.getAverage();
  }
}
